<template>
  <div class="container">
    <Input
      placeholder="请输入客户名"
      clearable
      style="width: 300px"
      search
      v-model="searchtext"
      @on-change="searchCustomer"
    />
    <div class="page flex-space-between">
      <SelectUserDropDown 
        @selectUser="selectUser"
        :selectedUser="selectedUser"/>
      <div class="flex-space-between">
        <div>共{{ totalRows }}条</div>
        <Page
          :total="totalRows"
          :page-size="limit"
          @on-change="loadCustomer"
          show-total
          simple
          style="margin-right: 24px"
        />
      </div>
      
    </div>

    <Row :gutter="12" class="table-title">
      <Col span="10">
        客户
      </Col>
      <Col span="4">
        欠款
      </Col>
      <Col span="4">
        收款
      </Col>
      <Col span="6">
        销量
      </Col>
    </Row>
    
    <div class="customer-wrapper" ref="tableWrapper">
      
      <div
        :class="{selected: selectedCustomer?._id === salesStat.customer?._id}"
        class="customer-card"
        v-for="salesStat in statViewC"
        @click="showCustomerDetail(salesStat.customer)"
        :key='salesStat._id'>
        <Row :gutter="12">
          <Col span="10">
            {{ salesStat.customer.name }}
          </Col>
          <Col span="4">
            {{ (salesStat.totalAccountsReceivable/10000).toFixed(2) }}万
            <br>
            ({{ salesStat.longestARMonthCount }}个月)
          </Col>
          <Col span="4">
            <span v-if="salesStat.receiveAfterSpecDate === 0" style="color: lightgray;">-</span>
            <span v-else>{{ (salesStat.receiveAfterSpecDate/10000).toFixed(2) }}万</span>
            
          </Col>
          <Col span="6">
            {{ salesStat.vol }}
          </Col>
        </Row>
        
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { cusStatusTrans } from "@/utils";
import SelectUserDropDown from "@/components/SelectUserDropDown.vue";

export default {
  name: "CustomerSearchSidebar",
  components: {
    SelectUserDropDown,
  },
  data() {
    return {
      searchtext: "",
      selectedUser: null,
      tableHeight: 300,
      page: 0,
      limit: 55,
      filterQuery: {},
      tableLoading: false,
    };
  },
  computed: {
    ...mapState({
      selectedCustomer: (state) => state.customerAnalyze.selectedCustomer,
      statViewC: (state) => state.customerAnalyze.statViewC,
      totalRows: (state) => state.customerAnalyze.statViewCCounts,
    }),
    ...mapGetters({
    }),
  },
  methods: {
    ...mapActions({
      getStatViewC: "customerAnalyze/getStatViewCAction",
      selectCustomer: "customerAnalyze/selectCustomerAction",
    }),
    async loadCustomer(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      if (this.searchtext) {
        this.filterQuery.cus_name = this.searchtext;
      } else {
        delete this.filterQuery.cus_name;
      }
      if (this.selectedUser) {
        this.filterQuery.devSales = this.selectedUser._id;
      }
      try {
        await this.getStatViewC(this.filterQuery)
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    searchCustomer() {
      this.page = 0;
      this.loadCustomer();
    },
    selectUser(user) {
      this.selectedUser = user;
      this.loadCustomer();
    },
    async showCustomerDetail(customer) {
      await this.selectCustomer(customer);
      this.$router.push({
        name: this.$route.name,
        query: {
          id: customer._id,
        },
      });
      // let customerInfo = this.getCustomerById(item._id);
      // this.saveCustomer(customerInfo);
      // this.setDetailCustomersId(item._id);
      // let api = { skip: this.page * 10, customer: item._id };
      // this.getSalesRecordList(api);
    },
  },
  async mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
    await this.loadCustomer();
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped lang="stylus">
.container
  padding 25px 15px
  width 550px
  border-right 1px solid #c9c9c9

.customer-wrapper
  overflow-y scroll
  overflow-x hidden
  height calc(100% - 100px)

.table-title
  font-size 15px
  padding 4px
  border-bottom 1px solid #ececec
  width 512px

.customer-card
  cursor pointer
  font-size 15px
  padding 4px
  border-bottom 1px solid #ececec
  &:hover
    background-color #ececec
.selected
  font-weight bold
  color #2d8cf0
  background-color #eaf4ff
.page
  margin-top 15px

.flex-space-between
  display flex
  justify-content space-between
  align-items center
</style>